import axios from "axios";
import Cookie from "@/utils/cache.js";
// import { messageD } from "element-plus";
import { messageD } from "../utils/message.js";
import { netErrorCode } from "../config/netErrorCode";
import globalStore from "../store/global";
import userStore from "../store/user";
import router from "../router";

export let baseUrl = import.meta.env["VITE_APP_API"];
console.log(baseUrl, 123);
const lang = localStorage.getItem("lang")
  ? localStorage.getItem("lang") === "zh"
    ? "zh-cn"
    : "en-US"
  : "zh-cn";
// const { promiseBaseUrl } = document.querySelector("html").dataset;
if (!baseUrl) {
  baseUrl = window.location.origin + "/";
}

// if (promiseBaseUrl) {
//   baseUrl = `${promiseBaseUrl}`;
// } else if (["localhost"].includes(window.location.hostname)) {
//   baseUrl = import.meta.env["VITE_APP_API"];
// } else {
//   baseUrl = window.location.origin + "/";
// }
// if (promiseBaseUrl) {
//   baseUrl = import.meta.env["VITE_APP_API"];
// } else if (["localhost"].includes(window.location.hostname)) {
//   baseUrl = import.meta.env["VITE_APP_API"];
// } else {
//   baseUrl = import.meta.env["VITE_APP_API"];
// }

export const headers = () => {
  const header = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + Cookie.get("accessTokenMa"),
    "X-Authorization": "Bearer " + Cookie.get("xAccessTokenMa"),
    "Accept-Language": lang,
  };
  return header;
};
export const formDataHeaders = () => {
  const header = {
    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    Authorization: "Bearer " + Cookie.get("accessTokenMa"),
    "X-Authorization": "Bearer " + Cookie.get("xAccessTokenMa"),
    "Accept-Language": lang,
  };
  return header;
};
export const downloadHeaders = () => {
  const header = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + Cookie.get("accessTokenMa"),
    "X-Authorization": "Bearer " + Cookie.get("xAccessTokenMa"),
    "Accept-Language": lang,
  };
  return header;
};

const http = axios.create({
  timeout: 1000 * 60 * 60,
  validateStatus: function (status) {
    return status >= 200 && status < 300;
  },
});
http.interceptors.request.use(
  function (config) {
    globalStore.data.loading++;
    return config;
  },
  function (error) {
    globalStore.data.loading = 0;
    return Promise.reject(error);
  }
);
// 响应拦截器
http.interceptors.response.use(
  (config) => {
    globalStore.data.loading--;
    const token = config.headers["access-token"];
    const xtoken = config.headers["x-access-token"];
    if (token) {
      Cookie.set("accessTokenMa", token);
    }
    if (xtoken) {
      Cookie.set("xAccessTokenMa", xtoken);
    }
    const data = config.data;
    if (data?.errors == "[SchemeNotFound] 方案未发现") {
      // userStore.loginOut();
      messageD.error("方案未发现");
    }
    if (data.statusCode === 400) {
      if (data.errors == "[NoMatchYet] 暂无匹配") {
        throw new Error("请检查接口参数");
      }
      // if (data.errors?.match(/[\u4e00-\u9fa5]/g)) {
      //   messageD.error(data.errors?.match(/[\u4e00-\u9fa5]/g).join(""));
      // }
      messageD.error(JSON.stringify(data.errors));
      throw new Error("请检查接口参数");
    }
    if (data.statusCode === 500) {
      messageD.error(data.errors || "服务端错误");
      // if (data.errors?.match(/[\u4e00-\u9fa5]/g)) {
      //   messageD.error(
      //     "服务端错误: " + data.errors?.match(/[\u4e00-\u9fa5]/g).join("")
      //   );
      // } else {
      //   messageD.error("服务端错误");
      // }
      throw new Error("服务端错误");
    }
    if (data.statusCode === 200) {
      return data;
    }
    if (config.data.type == "application/qtx" || "application/json") {
      // 流文件
      if (
        config.headers["content-type"].includes("document") ||
        config.headers["content-type"].includes("octet-stream") ||
        config.headers["content-type"].includes("pdf")
      ) {
        return data;
      } else {
        messageD.error("打印失败,请检查参数");
        throw new Error("打印失败,请检查参数");
      }
    }
  },
  (err) => {
    globalStore.data.loading--;
    console.log(err);
    if (err && err.response) {
      const status = err.response.status;
      let errorMessage = netErrorCode[status];
      //401 403
      if (status === 401) {
        messageD.error("您当前未登录,请登陆");
        userStore.loginOut();
        // globalStore.data.loading--;
      } else if (status === 403) {
        router.push("/403");
        // globalStore.data.loading--;
      } else {
        console.log(errorMessage);
        messageD.error(errorMessage);
        // globalStore.data.loading = 0;
      }
    }
    return Promise.reject(err);
  }
);

/**
 * @param {string} url 必填
 * @returns {Object} params
 */
export const get = async (url, params = {}) =>
  http({
    method: "get",
    url: encodeURI(baseUrl + url),
    params,
    headers: headers(),
  });

/**
 * @param {string} url 必填
 * @returns {Object} params
 */
export const downloadGet = async (url, fileName = "文件夹") => {
  http({
    method: "get",
    url: encodeURI(baseUrl + url),
    headers: headers(),
    responseType: "blob",
    onDownloadProgress: (progressEvent) => {
      console.log(progressEvent, 1111);
    },
  }).then((res) => {
    let url = window.URL.createObjectURL(new Blob([res]));
    let a = document.createElement("a");
    a.href = url;
    a.style.display = "none";
    a.setAttribute("download", `${fileName}`);
    document.body.appendChild(a);
    a.click();
    a.remove();
  });
};

/**
 * @param {string} url 必填
 * @returns {Object} params
 */
export const post = async (url, params = {}, api = "VITE_APP_API") =>
  http({
    method: "post",
    url: baseUrl + url,
    data: params,
    headers: headers(),
  });
export const printPdfPost = async (url, params = {}, api = "VITE_APP_API") =>
  http({
    method: "post",
    url: baseUrl + url,
    data: params,
    headers: headers(),
    responseType: "blob", // 必须更改responseType类型为 blob
  });
export const del = async (url, params = {}, api = "VITE_APP_API") =>
  http({
    method: "delete",
    url: baseUrl + url,
    data: params,
    headers: headers(),
  });
export const put = async (url, params = {}, api = "VITE_APP_API") =>
  http({
    method: "put",
    url: baseUrl + url,
    data: params,
    headers: headers(),
  });
export const upload = async (url, params = {}, api = "VITE_APP_API") => {
  const formdata = new FormData();
  Object.keys(params).map((key) => {
    if (Array.isArray(params[key]))
      for (let i = 0; i < params[key].length; i++) {
        formdata.append(`${key}`, params[key][i]);
      }
    else formdata.append(key, params[key]);
  });
  return http({
    method: "post",
    url: baseUrl + url,
    data: formdata,
    headers: formDataHeaders(),
  });
};
export const uploadPut = async (url, params = {}, api = "VITE_APP_API") => {
  const formdata = new FormData();
  Object.keys(params).map((key) => {
    if (Array.isArray(params[key]))
      for (let i = 0; i < params[key].length; i++) {
        console.log(params);
        formdata.append(`${key}`, params[key][i]);
      }
    else formdata.append(key, params[key]);
  });
  return http({
    method: "put",
    url: baseUrl + url,
    data: formdata,
    headers: formDataHeaders(),
  });
};
export const uploadPost = async (url, params = {}, api = "VITE_APP_API") => {
  const formdata = new FormData();
  Object.keys(params).map((key) => formdata.append(key, params[key]));
  return http({
    method: "post",
    url: baseUrl + url,
    data: formdata,
    headers: formDataHeaders(),
  });
};
/**
 * @param {url} 请求地址
 * @param {params} 请求参数
 * @param {fileName} 文件名
 * @param {isPreview} 是否需要预览 仅限pdf
 * @return:
 */
export const download = (url, params, fileName, isPreview) => {
  http({
    method: "post",
    url: baseUrl + url,
    data: params,
    headers: downloadHeaders(),
    responseType: "blob",
  }).then(function (res) {
    if (isPreview) {
      let url = window.URL.createObjectURL(
        new Blob([res], { type: "application/pdf" })
      );
      console.log(res);
      window.open(url, "blank");
      window.URL.revokeObjectURL(url);
    } else {
      let url = window.URL.createObjectURL(new Blob([res]));

      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", `${fileName}`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    }
  });
};
const getFileName = () => {
  const now = new Date();
  const year = now.getFullYear();
  let month = now.getMonth() + 1;
  let day = now.getDate();
  let hour = now.getHours();
  let minutes = now.getMinutes();
  let seconds = now.getSeconds();
  String(month).length < 2 ? (month = Number("0" + month)) : month;
  String(day).length < 2 ? (day = Number("0" + day)) : day;
  String(hour).length < 2 ? (hour = Number("0" + hour)) : hour;
  String(minutes).length < 2 ? (minutes = Number("0" + minutes)) : minutes;
  String(seconds).length < 2 ? (seconds = Number("0" + seconds)) : seconds;
  return `${year}${month}${day}${hour}${minutes}${seconds}.xlsx`;
};

export default { get, post, download, del, put, printPdfPost };
